import * as React from 'react';
export const bancontactSvg = React.forwardRef(function bancontactSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#EBF1F7',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: 'url(#bi_bancontact__a)',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M8.164 21.448c3.918 0 5.877-2.612 7.836-5.224H3v5.224h5.164Z',
        fill: 'url(#bi_bancontact__b)',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M23.836 11c-3.918 0-5.877 2.612-7.836 5.224h13V11h-5.164Z',
        fill: 'url(#bi_bancontact__c)',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_bancontact__b',
          x1: 5.629,
          y1: 19.077,
          x2: 15.139,
          y2: 15.544,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#005AB9',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#1E3764',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_bancontact__c',
          x1: 16.787,
          y1: 16.677,
          x2: 26.885,
          y2: 13.232,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#FBA900',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#FFD800',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: 'bi_bancontact__a',
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#fff',
          transform: 'translate(3 11)',
          d: 'M0 0h26v10.447H0z',
        }),
      ),
    ),
  );
});
bancontactSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var bancontact = {
  category: 'brand',
  colorable: false,
  name: 'bancontact',
  svg: bancontactSvg,
};
